export enum KriWidgetType {
    All = 1,
    Kri = 2,
    Kpi = 3,
}

// The string values are i18n keys resolved via the `transloco` pipe at the display site
export const KriWidgetTypeDescription: { [type in KriWidgetType]: string } = {
    1: "dashboard.widgetCatalog.kriWidgetTypeAllOption",
    2: "dashboard.widgetCatalog.kriWidgetTypeKriOption",
    3: "dashboard.widgetCatalog.kriWidgetTypeKpiOption",
};
